import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue'
import { ElDialog } from 'element-plus'
import useI18nTl from '@/hooks/useI18nTl'
import { getEvseProfileLately } from '@/api/evses'
import EvseProflieSchedule from './EvseProflieSchedule.vue'

export type OperationType = 'create' | 'edit'


import { defineComponent } from 'vue'
import { duration } from 'moment'

const __default__ = defineComponent({
  name: 'EvseProflieLately',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  evseId: {
    type: String,
    required: true,
  },
  connectorNum: {
    type: Number,
    default: 1,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { t } = useI18nTl('Evses')



const proflieScheduledata = ref({
  cno: 1,
  duration: 0,
})
const updateSchedule = (val: any) => {
  console.log('lately=========接收到的更新数据2:', val)
  proflieScheduledata.value.cno = val.cno
  proflieScheduledata.value.duration = val.duration
}
const schedule = ref({})
const loadData = async () => {
  try {
    const { proflieSchedule = {} } = await getEvseProfileLately({
      evseId: props.evseId,
      cno: proflieScheduledata.value.cno,
      duration: proflieScheduledata.value.duration,
    })
    schedule.value = proflieSchedule
    proflieScheduledata.value = proflieSchedule
  } catch (error) {
    console.log(error)
  }
}

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      // loadData()
    }
  },
)

// const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    title: _unref(t)('Evses.latestChargingSchedule'),
    "append-to-body": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(EvseProflieSchedule, {
                "onUpdate:schedule": updateSchedule,
                "onSearch:lateLy": loadData,
                schedule: proflieScheduledata.value,
                connectorNum: props.connectorNum,
                isLately: true
              }, null, 8, ["schedule", "connectorNum"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})